// The first thing main.js imports. Inside an in-app browser (Discord, Instagram, TikTok and the
// like, see shared/inapp.js) it loads the "Open this page in Safari" banner; anywhere else it
// costs this check and nothing more. Loaded on its own, so the banner still comes up when the
// rest of the app cannot start there.
import { inAppBrowser } from "../shared/inapp.js";

let inappUrl = __RVM.inappJs; // a let, so esbuild leaves the import alone
try {
	let top = true;
	try { top = window.top === window; } catch { top = false; }
	if (top && inAppBrowser(navigator.userAgent, { sw: !!navigator.serviceWorker })) {
		const show = () => import(inappUrl).then((m) => m.showInAppBanner(window)).catch(() => {});
		if (document.body) show();
		else addEventListener("DOMContentLoaded", show, { once: true });
	}
} catch { /* never in the way of the app */ }
